/*
 *  Copyright © 2025 Cenozon Inc. All Rights Reserved.
 */
import serviceCall from '../serviceCall';

// Action Types
export const FETCH_JOINT_MATCHING_DATA_REQUEST = 'FETCH_JOINT_MATCHING_DATA_REQUEST';
export const FETCH_JOINT_MATCHING_DATA_SUCCESS = 'FETCH_JOINT_MATCHING_DATA_SUCCESS';
export const FETCH_JOINT_MATCHING_DATA_FAILURE = 'FETCH_JOINT_MATCHING_DATA_FAILURE';

export const FETCH_RUN_SUMMARY_REQUEST = 'FETCH_RUN_SUMMARY_REQUEST';
export const FETCH_RUN_SUMMARY_SUCCESS = 'FETCH_RUN_SUMMARY_SUCCESS';
export const FETCH_RUN_SUMMARY_FAILURE = 'FETCH_RUN_SUMMARY_FAILURE';

export const UPDATE_JOINT_MATCHING_FILTERS = 'UPDATE_JOINT_MATCHING_FILTERS';
export const CLEAR_JOINT_MATCHING_FILTERS = 'CLEAR_JOINT_MATCHING_FILTERS';

export const MATCH_JOINTS_REQUEST = 'MATCH_JOINTS_REQUEST';
export const MATCH_JOINTS_SUCCESS = 'MATCH_JOINTS_SUCCESS';
export const MATCH_JOINTS_FAILURE = 'MATCH_JOINTS_FAILURE';

export const UNMATCH_JOINTS_REQUEST = 'UNMATCH_JOINTS_REQUEST';
export const UNMATCH_JOINTS_SUCCESS = 'UNMATCH_JOINTS_SUCCESS';
export const UNMATCH_JOINTS_FAILURE = 'UNMATCH_JOINTS_FAILURE';

export const MATCH_MULTIPLE_JOINTS_REQUEST = 'MATCH_MULTIPLE_JOINTS_REQUEST';
export const MATCH_MULTIPLE_JOINTS_SUCCESS = 'MATCH_MULTIPLE_JOINTS_SUCCESS';
export const MATCH_MULTIPLE_JOINTS_FAILURE = 'MATCH_MULTIPLE_JOINTS_FAILURE';

export const UNMATCH_MULTIPLE_JOINTS_REQUEST = 'UNMATCH_MULTIPLE_JOINTS_REQUEST';
export const UNMATCH_MULTIPLE_JOINTS_SUCCESS = 'UNMATCH_MULTIPLE_JOINTS_SUCCESS';
export const UNMATCH_MULTIPLE_JOINTS_FAILURE = 'UNMATCH_MULTIPLE_JOINTS_FAILURE';

export const PROCESS_FEATURES_REQUEST = 'PROCESS_FEATURES_REQUEST';
export const PROCESS_FEATURES_SUCCESS = 'PROCESS_FEATURES_SUCCESS';
export const PROCESS_FEATURES_FAILURE = 'PROCESS_FEATURES_FAILURE';

export const PROCESS_TEMP_JOINTS_REQUEST = 'PROCESS_TEMP_JOINTS_REQUEST';
export const PROCESS_TEMP_JOINTS_SUCCESS = 'PROCESS_TEMP_JOINTS_SUCCESS';
export const PROCESS_TEMP_JOINTS_FAILURE = 'PROCESS_TEMP_JOINTS_FAILURE';

export const SAVE_TEMP_JOINTS_REQUEST = 'SAVE_TEMP_JOINTS_REQUEST';
export const SAVE_TEMP_JOINTS_SUCCESS = 'SAVE_TEMP_JOINTS_SUCCESS';
export const SAVE_TEMP_JOINTS_FAILURE = 'SAVE_TEMP_JOINTS_FAILURE';

export const PROCESS_JOINTS_MATCHING_REQUEST = 'PROCESS_JOINTS_MATCHING_REQUEST';
export const PROCESS_JOINTS_MATCHING_SUCCESS = 'PROCESS_JOINTS_MATCHING_SUCCESS';
export const PROCESS_JOINTS_MATCHING_FAILURE = 'PROCESS_JOINTS_MATCHING_FAILURE';

export const SET_SELECTED_JOINTS = 'SET_SELECTED_JOINTS';
export const CLEAR_SELECTED_JOINTS = 'CLEAR_SELECTED_JOINTS';

export const CHECK_TEMP_JOINTS_EXISTENCE_REQUEST = 'CHECK_TEMP_JOINTS_EXISTENCE_REQUEST';
export const CHECK_TEMP_JOINTS_EXISTENCE_SUCCESS = 'CHECK_TEMP_JOINTS_EXISTENCE_SUCCESS';
export const CHECK_TEMP_JOINTS_EXISTENCE_FAILURE = 'CHECK_TEMP_JOINTS_EXISTENCE_FAILURE';

// Run-to-Run Search Action Types
export const FETCH_RUN_SEARCH_FIELDS_REQUEST = 'FETCH_RUN_SEARCH_FIELDS_REQUEST';
export const FETCH_RUN_SEARCH_FIELDS_SUCCESS = 'FETCH_RUN_SEARCH_FIELDS_SUCCESS';
export const FETCH_RUN_SEARCH_FIELDS_FAILURE = 'FETCH_RUN_SEARCH_FIELDS_FAILURE';

export const FETCH_RUN_SEARCH_RESULTS_REQUEST = 'FETCH_RUN_SEARCH_RESULTS_REQUEST';
export const FETCH_RUN_SEARCH_RESULTS_SUCCESS = 'FETCH_RUN_SEARCH_RESULTS_SUCCESS';
export const FETCH_RUN_SEARCH_RESULTS_FAILURE = 'FETCH_RUN_SEARCH_RESULTS_FAILURE';

export const UPDATE_RUN_SEARCH_FILTERS = 'UPDATE_RUN_SEARCH_FILTERS';
export const CLEAR_RUN_SEARCH_FILTERS = 'CLEAR_RUN_SEARCH_FILTERS';
export const UPDATE_RUN_SEARCH_UI_STATE = 'UPDATE_RUN_SEARCH_UI_STATE';
export const SET_SELECTED_RUNS = 'SET_SELECTED_RUNS';

// Action Creators
export const fetchJointMatchingDataRequest = (runSid, requestId) => ({
   type: FETCH_JOINT_MATCHING_DATA_REQUEST,
   runSid,
   requestId
});

export const fetchJointMatchingDataSuccess = (data, runSid, requestId) => ({
   type: FETCH_JOINT_MATCHING_DATA_SUCCESS,
   payload: data,
   runSid,
   requestId
});

export const fetchJointMatchingDataFailure = (error, runSid, requestId) => ({
   type: FETCH_JOINT_MATCHING_DATA_FAILURE,
   payload: error,
   runSid,
   requestId
});

export const fetchRunSummaryRequest = (runSid, requestId) => ({
   type: FETCH_RUN_SUMMARY_REQUEST,
   runSid,
   requestId
});

export const fetchRunSummarySuccess = (data, runSid, requestId) => ({
   type: FETCH_RUN_SUMMARY_SUCCESS,
   payload: data,
   runSid,
   requestId
});

export const fetchRunSummaryFailure = (error, runSid, requestId) => ({
   type: FETCH_RUN_SUMMARY_FAILURE,
   payload: error,
   runSid,
   requestId
});

export const updateJointMatchingFilters = (filters) => ({
   type: UPDATE_JOINT_MATCHING_FILTERS,
   payload: filters
});

export const clearJointMatchingFilters = () => ({
   type: CLEAR_JOINT_MATCHING_FILTERS
});

export const matchJointsRequest = () => ({
   type: MATCH_JOINTS_REQUEST
});

export const matchJointsSuccess = (data) => ({
   type: MATCH_JOINTS_SUCCESS,
   payload: data
});

export const matchJointsFailure = (error) => ({
   type: MATCH_JOINTS_FAILURE,
   payload: error
});

export const unmatchJointsRequest = () => ({
   type: UNMATCH_JOINTS_REQUEST
});

export const unmatchJointsSuccess = (data) => ({
   type: UNMATCH_JOINTS_SUCCESS,
   payload: data
});

export const unmatchJointsFailure = (error) => ({
   type: UNMATCH_JOINTS_FAILURE,
   payload: error
});

export const matchMultipleJointsRequest = () => ({
   type: MATCH_MULTIPLE_JOINTS_REQUEST
});

export const matchMultipleJointsSuccess = (data) => ({
   type: MATCH_MULTIPLE_JOINTS_SUCCESS,
   payload: data
});

export const matchMultipleJointsFailure = (error) => ({
   type: MATCH_MULTIPLE_JOINTS_FAILURE,
   payload: error
});

export const unmatchMultipleJointsRequest = () => ({
   type: UNMATCH_MULTIPLE_JOINTS_REQUEST
});

export const unmatchMultipleJointsSuccess = (data) => ({
   type: UNMATCH_MULTIPLE_JOINTS_SUCCESS,
   payload: data
});

export const unmatchMultipleJointsFailure = (error) => ({
   type: UNMATCH_MULTIPLE_JOINTS_FAILURE,
   payload: error
});

export const processFeaturesRequest = () => ({
   type: PROCESS_FEATURES_REQUEST
});

export const processFeaturesSuccess = (data) => ({
   type: PROCESS_FEATURES_SUCCESS,
   payload: data
});

export const processFeaturesFailure = (error) => ({
   type: PROCESS_FEATURES_FAILURE,
   payload: error
});

export const processTempJointsRequest = () => ({
   type: PROCESS_TEMP_JOINTS_REQUEST
});

export const processTempJointsSuccess = (data) => ({
   type: PROCESS_TEMP_JOINTS_SUCCESS,
   payload: data
});

export const processTempJointsFailure = (error) => ({
   type: PROCESS_TEMP_JOINTS_FAILURE,
   payload: error
});

export const saveTempJointsRequest = () => ({
   type: SAVE_TEMP_JOINTS_REQUEST
});

export const saveTempJointsSuccess = (data) => ({
   type: SAVE_TEMP_JOINTS_SUCCESS,
   payload: data
});

export const saveTempJointsFailure = (error) => ({
   type: SAVE_TEMP_JOINTS_FAILURE,
   payload: error
});

export const setSelectedJoints = (masterJoint, targetJoint) => ({
   type: SET_SELECTED_JOINTS,
   payload: { masterJoint, targetJoint }
});

export const clearSelectedJoints = () => ({
   type: CLEAR_SELECTED_JOINTS
});

export const checkTempJointsExistenceRequest = (runSid, requestId) => ({
   type: CHECK_TEMP_JOINTS_EXISTENCE_REQUEST,
   requestId,
   runSid
});

export const checkTempJointsExistenceSuccess = (hasTempJoints, requestId) => ({
   type: CHECK_TEMP_JOINTS_EXISTENCE_SUCCESS,
   payload: hasTempJoints,
   requestId
});

export const checkTempJointsExistenceFailure = (error, requestId) => ({
   type: CHECK_TEMP_JOINTS_EXISTENCE_FAILURE,
   payload: error,
   requestId
});

// Run-to-Run Search Action Creators
export const fetchRunSearchFieldsRequest = () => ({
   type: FETCH_RUN_SEARCH_FIELDS_REQUEST
});

export const fetchRunSearchFieldsSuccess = (data) => ({
   type: FETCH_RUN_SEARCH_FIELDS_SUCCESS,
   payload: data
});

export const fetchRunSearchFieldsFailure = (error) => ({
   type: FETCH_RUN_SEARCH_FIELDS_FAILURE,
   payload: error
});

export const fetchRunSearchResultsRequest = (requestId) => ({
   type: FETCH_RUN_SEARCH_RESULTS_REQUEST,
   requestId
});

export const fetchRunSearchResultsSuccess = (data, requestId) => ({
   type: FETCH_RUN_SEARCH_RESULTS_SUCCESS,
   payload: data,
   requestId
});

export const fetchRunSearchResultsFailure = (error, requestId) => ({
   type: FETCH_RUN_SEARCH_RESULTS_FAILURE,
   payload: error,
   requestId
});

export const updateRunSearchFilters = (filters) => ({
   type: UPDATE_RUN_SEARCH_FILTERS,
   payload: filters
});

export const clearRunSearchFilters = () => ({
   type: CLEAR_RUN_SEARCH_FILTERS
});

export const updateRunSearchUIState = (uiState) => ({
   type: UPDATE_RUN_SEARCH_UI_STATE,
   payload: uiState
});

export const setSelectedRuns = (masterRun, targetRun) => ({
   type: SET_SELECTED_RUNS,
   payload: { masterRun, targetRun }
});

// Async Action Creators (Thunks)
// Monotonic per-fetch-type counters so the reducer can drop a superseded response
let latestJointMatchingRequestId = 0;
let latestRunSummaryRequestId = 0;
let latestTempJointsRequestId = 0;

export const fetchJointMatchingData = (runSid) => {
   return async (dispatch, getState) => {
      const requestId = ++latestJointMatchingRequestId;
      dispatch(fetchJointMatchingDataRequest(runSid, requestId));

      try {
         // runSid is mandatory - call API endpoint with runSid parameter
         const response = await serviceCall.getAllData(`RunToRunMatching/GetJointsMatchingResults/${runSid}`);

         if (response && response.data && response.status === 200) {
            dispatch(fetchJointMatchingDataSuccess(response.data, runSid, requestId));
         } else {
            throw new Error('Failed to fetch joint matching data');
         }

      } catch (error) {
         dispatch(fetchJointMatchingDataFailure(error.message || 'Failed to fetch joint matching data', runSid, requestId));
      }
   };
};

export const fetchRunSummary = (runSid) => {
   return async (dispatch, getState) => {
      const requestId = ++latestRunSummaryRequestId;
      dispatch(fetchRunSummaryRequest(runSid, requestId));

      try {
         // runSid is mandatory - call API endpoint with runSid parameter
         const response = await serviceCall.getAllData(`RunToRunMatching/GetRunSummary/${runSid}`);

         if (response && response.data && response.status === 200) {
            dispatch(fetchRunSummarySuccess(response.data, runSid, requestId));
         } else {
            throw new Error('Failed to fetch run summary');
         }

      } catch (error) {
         dispatch(fetchRunSummaryFailure(error.message || 'Failed to fetch run summary', runSid, requestId));
      }
   };
};

export const matchJoints = (masterJoint, targetJoint) => {
   return async (dispatch, getState) => {
      dispatch(matchJointsRequest());
      
      try {
         const response = await serviceCall.postData('RunToRunMatching/MatchJoints', {
            masterJoint,
            targetJoint
         });
         
         if (response && response.data && response.status === 200) {
            dispatch(matchJointsSuccess(response.data));
            // Reload the data after successful match - get runSid from state
            const state = getState();
            const runSid = state.runToRunMatching?.runSummary?.runSid;
            if (runSid) {
               dispatch(fetchJointMatchingData(runSid));
            }
         } else {
            throw new Error('Failed to match joints');
         }
         
      } catch (error) {
         dispatch(matchJointsFailure(error.message || 'Failed to match joints'));
      }
   };
};

export const unmatchJoints = (jointIds) => {
   return async (dispatch, getState) => {
      dispatch(unmatchJointsRequest());
      
      try {
         const response = await serviceCall.postData('RunToRunMatching/UnmatchJoints', {
            jointIds
         });
         
         if (response && response.data && response.status === 200) {
            dispatch(unmatchJointsSuccess(response.data));
            // Reload the data after successful unmatch - get runSid from state
            const state = getState();
            const runSid = state.runToRunMatching?.runSummary?.runSid;
            if (runSid) {
               dispatch(fetchJointMatchingData(runSid));
            }
         } else {
            throw new Error('Failed to unmatch joints');
         }
         
      } catch (error) {
         dispatch(unmatchJointsFailure(error.message || 'Failed to unmatch joints'));
      }
   };
};

export const matchMultipleJoints = (jointsMatchingData) => {
   return async (dispatch, getState) => {
      dispatch(matchMultipleJointsRequest());
      
      try {
         // Call your existing MatchJoints POST API endpoint
         const response = await serviceCall.postData('RunToRunMatching/SaveTempJoints', jointsMatchingData);
         
         if (response && response.status === 200) {
            dispatch(matchMultipleJointsSuccess(response.data));
            // Reload the data after successful batch match - get runSid from state
            const state = getState();
            const runSid = state.runToRunMatching?.runSummary?.runSid;
            if (runSid) {
               dispatch(fetchJointMatchingData(runSid));
            }
         } else {
            throw new Error('Failed to match multiple joints');
         }
         
      } catch (error) {
         dispatch(matchMultipleJointsFailure(error.message || 'Failed to match multiple joints'));
      }
   };
};

export const unmatchMultipleJoints = (jointsMatchingData) => {
   return async (dispatch, getState) => {
      dispatch(unmatchMultipleJointsRequest());
      
      try {
         // Call your UnMatchJoints POST API endpoint with the same data format
         const response = await serviceCall.postData('RunToRunMatching/SaveTempJoints', jointsMatchingData);
         
         if (response && response.status === 200) {
            dispatch(unmatchMultipleJointsSuccess(response.data));
            // Reload the data after successful batch unmatch - get runSid from state
            const state = getState();
            const runSid = state.runToRunMatching?.runSummary?.runSid;
            if (runSid) {
               dispatch(fetchJointMatchingData(runSid));
            }
         } else {
            throw new Error('Failed to unmatch multiple joints');
         }
         
      } catch (error) {
         dispatch(unmatchMultipleJointsFailure(error.message || 'Failed to unmatch multiple joints'));
      }
   };
};

export const processFeatures = (runSid) => {
   return async (dispatch, getState) => {
      dispatch(processFeaturesRequest());
      
      try {
         // Call your process-features GET API endpoint with runSid as query parameter
         const response = await serviceCall.getAllData(`RunToRunMatching/processfeatures/${runSid}`);
         
         if (response && response.status === 200) {
            dispatch(processFeaturesSuccess(response.data));
            // Optionally reload the data after successful feature processing
            dispatch(fetchJointMatchingData(runSid));
         } else {
            throw new Error('Failed to process features');
         }
         
      } catch (error) {
         dispatch(processFeaturesFailure(error.message || 'Failed to process features'));
      }
   };
};

export const processTempJoints = (runSid) => {
   return async (dispatch, getState) => {
      dispatch(processTempJointsRequest());
      
      try {
         // Call your ProcessTempJoints GET API endpoint with runSid as query parameter
         const response = await serviceCall.getAllData(`RunToRunMatching/ProcessTempJoints/${runSid}`);
         
         if (response && response.status === 200) {
            dispatch(processTempJointsSuccess(response.data));
            // Check temp joints existence after processing (should be false after processing)
            dispatch(checkTempJointsExistence(runSid));
         } else {
            throw new Error('Failed to process temp joints');
         }
         
      } catch (error) {
         dispatch(processTempJointsFailure(error.message || 'Failed to process temp joints'));
      }
   };
};

export const saveTempJoints = (jointsMatchingData) => {
   return async (dispatch, getState) => {
      dispatch(saveTempJointsRequest());
      
      try {
         // Call your SaveTempJoints POST API endpoint with joints matching data
         const response = await serviceCall.postData('RunToRunMatching/SaveTempJoints', jointsMatchingData);
         
         if (response && response.status === 200) {
            dispatch(saveTempJointsSuccess(response.data));
            // Optionally reload the data after successful saving - get runSid from state
            const state = getState();
            const runSid = state.runToRunMatching?.runSummary?.runSid;
            if (runSid) {
               // Check temp joints existence after saving
               dispatch(checkTempJointsExistence(runSid));
            }
         } else {
            throw new Error('Failed to save temp joints');
         }
         
      } catch (error) {
         dispatch(saveTempJointsFailure(error.message || 'Failed to save temp joints'));
      }
   };
};

// Process Joints Matching Action Creators
export const processJointsMatchingRequest = () => ({
   type: PROCESS_JOINTS_MATCHING_REQUEST
});

export const processJointsMatchingSuccess = (data) => ({
   type: PROCESS_JOINTS_MATCHING_SUCCESS,
   payload: data
});

export const processJointsMatchingFailure = (error) => ({
   type: PROCESS_JOINTS_MATCHING_FAILURE,
   payload: error
});

// Run-to-Run Search Async Actions
export const fetchRunSearchFields = (searchFilters = {}) => {
   return async (dispatch) => {
      dispatch(fetchRunSearchFieldsRequest());
      
      try {
         const response = await serviceCall.postData('RunToRunMatching/GetRunSearchFields', searchFilters);
         
         if (response && response.data && response.status === 200) {
            dispatch(fetchRunSearchFieldsSuccess(response.data));
         } else {
            throw new Error('Failed to fetch run search fields');
         }
         
      } catch (error) {
         dispatch(fetchRunSearchFieldsFailure(error.message || 'Failed to fetch run search fields'));
      }
   };
};

// Module-scoped counter so the reducer can tell an in-flight request's response
// apart from a newer one dispatched after it (e.g. two searches fired in close
// succession on mount) — an older response arriving late must never overwrite
// a newer one's results.
let latestRunSearchRequestId = 0;

export const fetchRunSearchResults = (searchParams) => {
   return async (dispatch) => {
      const requestId = ++latestRunSearchRequestId;
      dispatch(fetchRunSearchResultsRequest(requestId));

      try {
         // Use the filtering endpoint with search parameters
         const response = await serviceCall.postData('RunToRunMatching/GetRunSummaryResults', searchParams);

         if (response && response.data && response.status === 200) {
            // Response should already be in the expected structure from the new method
            dispatch(fetchRunSearchResultsSuccess(response.data, requestId));
         } else if (response && response.status === 204) {
            // No data found
            dispatch(fetchRunSearchResultsSuccess({ results: [], __count: 0 }, requestId));
         } else {
            throw new Error('Failed to fetch run search results');
         }

      } catch (error) {
         dispatch(fetchRunSearchResultsFailure(error.message || 'Failed to fetch run search results', requestId));
      }
   };
};

// Process Joints Matching Async Action
export const processJointsMatching = (jointsMatchingInputDto) => {
   return async (dispatch) => {
      try {
         dispatch(processJointsMatchingRequest());
         
         const response = await serviceCall.postData('RunToRunMatching/ProcessJointsMatching', jointsMatchingInputDto);
         
         if (response && response.status === 200) {
            dispatch(processJointsMatchingSuccess(response.data));
            return response.data;
         } else {
            throw new Error('Failed to process joints matching');
         }
         
      } catch (error) {
         dispatch(processJointsMatchingFailure(error.message || 'Failed to process joints matching'));
         throw error;
      }
   };
};

// Check Temp Joints Existence Async Action
export const checkTempJointsExistence = (runSid) => {
   return async (dispatch) => {
      const requestId = ++latestTempJointsRequestId;
      dispatch(checkTempJointsExistenceRequest(runSid, requestId));

      try {
         const response = await serviceCall.getAllData(`RunToRunMatching/HasTempJoints/${runSid}`);

         if (response && response.data && response.status === 200) {
            dispatch(checkTempJointsExistenceSuccess(response.data.hasTempJoints, requestId));
         } else {
            throw new Error('Failed to check temp joints existence');
         }

      } catch (error) {
         dispatch(checkTempJointsExistenceFailure(error.message || 'Failed to check temp joints existence', requestId));
      }
   };
};
